import React, {useEffect} from "react";
import "./HangarDetailedView.scss";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import HangarDetailedHeader from "../HangarDetailedHeader/HangarDetailedHeader";
import HangarDetailedAircraft from "../HangarDetailedAircraft/HangarDetailedAircraft";
import { useSelector, useDispatch } from "react-redux";
import { setMenuSelection } from "../../../storage/reducers/menuSelectorReducer";
import { APP_TITLES } from "../../../helper/constants";

const HangarDetailedView = (props) => {
    const { t } = useTranslation();
    const aircraftDetails = useSelector((state) => state.aircraft.aircraftDetails);
    const location = useLocation();
    const data= location.state;
    const dispatch = useDispatch();

    useEffect(() => {
      dispatch(setMenuSelection({currentMenuTitle: APP_TITLES.AIRCRAFT_VIEW}));
    }, []);

   return (
     <>
      <HangarDetailedHeader 
        id={aircraftDetails?.id} 
        aircraftMake={aircraftDetails?.aircraft_make} 
        aircraftModel={aircraftDetails?.aircraft_model} 
        aircraftName={aircraftDetails?.aircraft_name} 
        notificationFlag={aircraftDetails?.notification_flag} 
        fms={aircraftDetails?.fms_version}
        />  
          <HangarDetailedAircraft 
        id={aircraftDetails?.id}  
        aircraftMake={aircraftDetails?.aircraftMake} 
        aircraftModel={aircraftDetails?.aircraftModel} 
        />  
       </>
    ); 
};
export default HangarDetailedView;


